import { useEffect, useState } from 'react';
import { ImageOverlay } from 'react-leaflet';
import { useLayers } from '../../context/LayersContext';
import L from 'leaflet';

const WIND_LAYER_KEY = 'Velocidade do vento (10m/s)';

const IMAGE_URL =
  'https://globalwindatlas.info/api/gis/country/BRA/wind-speed/10';

const FULL_BOUNDS = L.latLngBounds(
  L.latLng(-55.0, -85.0), // SW do Brasil
  L.latLng(15.0, -30.0) // NE do Brasil
);

export function RenderGlobalWind() {
  const { layers } = useLayers();
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    if (layers.includes(WIND_LAYER_KEY)) {
      setImageUrl(IMAGE_URL);
    } else {
      setImageUrl(null);
    }
  }, [layers]);

  if (!imageUrl) return null;

  return (
    <ImageOverlay
      url={imageUrl}
      bounds={FULL_BOUNDS}
      opacity={0.6}
      zIndex={10}
    />
  );
}
